import { ActionResolveInput } from '@evidentid/tprm-portal-lib/models/entity-actions-review';
import {
    ContractExtractionResolveInput,
} from '@evidentid/tprm-portal-lib/models/entity-actions-review/actions/contract-extraction/ContractExtractionResolveInput.model';

export function extractConflictEmail(resolve: ActionResolveInput): string | undefined {
    const data = resolve as ContractExtractionResolveInput;
    return data.riskProfile?.entity?.type === 'New'
        ? data.riskProfile.entity.entity.contactEmail
        : undefined;
}

export function transformToExistingEntityResolve(
    resolve: ActionResolveInput,
    entityId: string,
): ActionResolveInput {
    const data = resolve as ContractExtractionResolveInput;
    if (!data.riskProfile || data.riskProfile.entity?.type !== 'New') {
        return resolve;
    }
    return {
        ...data,
        riskProfile: {
            ...data.riskProfile,
            entity: { type: 'Existing', entityId },
        },
    };
}
